var map = {
	"./views/BlogView": "c2f7",
	"./views/BlogView.vue": "c2f7",
	"./views/BlogsView": "f0f2",
	"./views/BlogsView.vue": "f0f2",
	"./views/BrandsView": "865f",
	"./views/BrandsView.vue": "865f",
	"./views/Buyback": "7e24",
	"./views/Buyback.vue": "7e24",
	"./views/CategoriesView": "9adf",
	"./views/CategoriesView.vue": "9adf",
	"./views/FlashDealsView": "ada9",
	"./views/FlashDealsView.vue": "ada9",
	"./views/HomeView": "7d97",
	"./views/HomeView.vue": "7d97",
	"./views/LoginView": "3bea",
	"./views/LoginView.vue": "3bea",
	"./views/PasswordResetView": "6439",
	"./views/PasswordResetView.vue": "6439",
	"./views/ProductView": "7901",
	"./views/ProductView.vue": "7901",
	"./views/ProductsListView": "8c3f",
	"./views/ProductsListView.vue": "8c3f",
	"./views/RefundView": "d0d9",
	"./views/RefundView.vue": "d0d9",
	"./views/RegisterView": "e846",
	"./views/RegisterView.vue": "e846",
	"./views/SeckillView": "1029",
	"./views/SeckillView.vue": "1029",
	"./views/SellersView": "fcdc",
	"./views/SellersView.vue": "fcdc",
	"./views/ShopCreate": "f8c4",
	"./views/ShopCreate.vue": "f8c4",
	"./views/ShopView": "6803",
	"./views/ShopView.vue": "6803",
	"./views/TermsView": "78cf",
	"./views/TermsView.vue": "78cf",
	"./views/WishlistView": "9187",
	"./views/WishlistView.vue": "9187",
	"./views/download": "565b",
	"./views/download.vue": "565b",
	"./views/loginToUser": "ff1e",
	"./views/loginToUser.vue": "ff1e",
	"./views/scan/tron_qrcode": "e886",
	"./views/scan/tron_qrcode.vue": "e886",
	"./views/seller/dashboard": "1266",
	"./views/seller/dashboard.vue": "1266",
	"./views/shopSupport": "704e",
	"./views/shopSupport.vue": "704e",
	"./views/support": "28ce",
	"./views/support.vue": "28ce",
	"./views/user": "e382",
	"./views/user/": "e382",
	"./views/user/NotificationsView": "dc2a",
	"./views/user/NotificationsView.vue": "dc2a",
	"./views/user/assist": "d603",
	"./views/user/assist.vue": "d603",
	"./views/user/cart": "e202",
	"./views/user/cart.vue": "e202",
	"./views/user/checkout": "4b17",
	"./views/user/checkout.vue": "4b17",
	"./views/user/checkoutDeliveryInfo": "4b4b",
	"./views/user/checkoutDeliveryInfo.vue": "4b4b",
	"./views/user/checkoutPayment": "8bf4",
	"./views/user/checkoutPayment.vue": "8bf4",
	"./views/user/compare": "40e2",
	"./views/user/compare.vue": "40e2",
	"./views/user/conversationDetail": "5416",
	"./views/user/conversationDetail.vue": "5416",
	"./views/user/conversations": "26a4",
	"./views/user/conversations.vue": "26a4",
	"./views/user/iconLetter": "8d17",
	"./views/user/iconLetter.vue": "8d17",
	"./views/user/index": "e382",
	"./views/user/index.vue": "e382",
	"./views/user/messageForm": "a71e",
	"./views/user/messageForm.vue": "a71e",
	"./views/user/messageList": "b0e8",
	"./views/user/messageList.vue": "b0e8",
	"./views/user/orderDetail": "99ad",
	"./views/user/orderDetail.vue": "99ad",
	"./views/user/orderList": "6e38",
	"./views/user/orderList.vue": "6e38",
	"./views/user/paySuccess": "1e73",
	"./views/user/paySuccess.vue": "1e73",
	"./views/user/profile": "669d",
	"./views/user/profile.vue": "669d",
	"./views/user/taskOrder": "5216",
	"./views/user/taskOrder.vue": "5216",
	"./views/user/taskOrderDetail": "8683",
	"./views/user/taskOrderDetail.vue": "8683",
	"./views/user/transactionPassword": "3705",
	"./views/user/transactionPassword.vue": "3705",
	"./views/user/wallet": "968b",
	"./views/user/wallet.vue": "968b",
	"./views/validCode": "71e8",
	"./views/validCode.vue": "71e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8c4";